import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            currentBalance: 0,
            companyName: '',
            invoices: [],
            dates6 : [],
            dates12 : [],
            showLoyalty: false,
            role: ''
        }
    },
    computed : {
        filteredInvoices : function () {
            return this.invoices;
        }
    },
    methods: {
        formatDate: formatDate,
        formatDate2: formatDate2,
        parseLocation: parseLocation,
        addInvoice: addInvoice,
        deleteInvoice: deleteInvoice,
        generatePdf: generatePdf,
        load: load,
        loadBalance: loadBalance,
        setPaid: setPaid,
        getPaymentClassTd: getPaymentClassTd,
        editMembership: editMembership,
         compare(a,b) {
            if (a.paidDate < b.paidDate)
                return 1;
            if (a.paidDate > b.paidDate)
                return -1;
            return 0;
        }
    },

    beforeMount() {
        this.role = session.getRole();
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        if(this.$route.query.companyName != null){
            if(session.getRole() !== 'ROLE_SUPER_ADMIN') {
                this.$router.push(CONFIG_COMPANY.HOME);
                return;
            }
            this.companyName = this.$route.query.companyName;
        }else{
            this.companyName = CONFIG_COMPANY.NAME
        }

        this.load()
        this.loadBalance()
    }
}

function loadBalance(){
    let _self = this;
    AdminApiService.getInvoicesCurrentBalance(this.companyName)
        .then((response) => {
            _self.currentBalance = response.data.currentBalance;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatDate2(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY')
}

function load() {
    let _self = this;
    AdminApiService.getInvoices(this.companyName)
        .then((response) => {
            _self.invoices = response.data;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function addInvoice() {
    this.$router.push('/add-invoice?companyName=' + this.companyName)
}

function deleteInvoice(id) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_invoice_are_you_sure_to_delete'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteInvoice(id)
            .then((response) => {
                _self.load()
                _self.loadBalance()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function getPaymentClassTd(item) {
    // if(payment.paidMoney <= 0){
    //     return "background: red;"
    // }
    return ''
}

function setPaid(item){
    if(item.isPaid) return;
    let _self = this;
    let model = {
        id: item.id,
        isPaid: true,
        payLastInvoice: false
    }
    swal({
        title: LocService.t("label_are_you_sure"),
        text: "Da li hocete odmah da se kreira i faktura placanja?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        model.payLastInvoice = true;
        AdminApiService.setPaidInvoice(model)
            .then((response) => {
                _self.load()
                _self.loadBalance()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    }).catch(function () {
        AdminApiService.setPaidInvoice(model)
            .then((response) => {
                _self.load()
                _self.loadBalance()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });


}

function editMembership(paymentId) {
    this.$router.push('/edit-membership-package?id=' + paymentId)
}

function parseLocation(inputString){
    const cleanedString = inputString.endsWith(";") ? inputString.slice(0, -1) : inputString;

    const pairs = cleanedString.split(";");

    // Kreiraj listu objekata sa `name` i `count`
    return pairs.map(pair => {
        const [name, count] = pair.split("->");
        return {
            name: name.trim(),
            count: parseInt(count.trim(), 10)
        };
    });
}

function generatePdf(invoice, downloadOnly){
    var amount = invoice.displayAmount;
    var currentDay = this.$moment(Date.now()).format('DD.MM.YYYY.')
    var currentDayInvoice = this.$moment(Date.now()).format('DD-MM-YYYY')
    var invoiceId = 'ID '+ invoice.id + '-' + currentDayInvoice;
    var discount = session.getConfig().discount;

    var mainBody = [];
    mainBody.push([{text: 'Usluga', style: 'miniHeaderTable2'}, {text: 'Broj korisnika', style: 'miniHeaderTable2'}, {text: 'Cena po korisniku', style: 'miniHeaderTable2'}, {text: 'Vrednost €', style: 'miniHeaderTable2'}])
    mainBody.push(['',{text: 'Ukupno:', style: 'mainHeaderTable'},'',{text: ''+invoice.amount.toFixed(2), style: 'mainRowTable'}])
    if(discount != null && discount > 0){
        mainBody.push(['',{text: 'Popust:', style: 'mainHeaderTable'},'',{text: ''+discount+'%', style: 'mainRowTable'}])
        mainBody.push(['',{text: 'Za plaćanje €:', style: 'mainHeaderTable'},'',{text: ''+invoice.amountWithDiscount.toFixed(2), style: 'mainRowTable'}])
    }else{
        mainBody.push(['',{text: 'Ukupno €:', style: 'mainHeaderTable'},'',{text: ''+invoice.amount.toFixed(2), style: 'mainRowTable'}])
        mainBody.push(['',{text: 'Za plaćanje €:', style: 'mainHeaderTable'},'',{text: ''+invoice.amount.toFixed(2), style: 'mainRowTable'}])
    }


    if(invoice.amount > 0){
        mainBody.splice(1, 0,  [{text: 'Usluge aplikacije' , style: 'mainRowTable'},{text: (invoice.itemCount).toFixed(2) + ' ', style: 'mainRowTable'},{text: ''+ (invoice.itemPrice).toFixed(2), style: 'mainRowTable'},{text: ''+ (invoice.amount).toFixed(2), style: 'mainRowTable'}]);
    }

    var locationDetails = [];
    if(invoice.locations != null && invoice.locations.length > 0){
        locationDetails.push([{text: 'Lokacija', style: 'mainHeaderTable'},{text: 'Broj članova', style: 'mainHeaderTable'}]);
        let locationList = this.parseLocation(invoice.locations)
        locationList.forEach(e => {
            locationDetails.push([{text: e.name, style: 'mainRowTable'},{text: e.count, style: 'mainRowTable'}]);
        })
    }

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var dd = {
        content: [
            {text: 'Termin Master', style: 'header'},
            {
                style: 'tableExample',
                table: {

                    headerRows: 1,
                    // dontBreakRows: true,
                    // keepWithHeaderRows: 1,
                    widths: ['*',  '*'],
                    body: [
                        [{text: '', style: 'tableHeader'}, {text: '', style: 'tableHeader'},],
                        [{text: 'Račun', style: 'headerRacun'}, {text: ''+invoice.partnerCompanyInfo , style:'companyInfo'} ],
                        [{
                            style: 'miniTableExample',
                            table: {
                                headerRows: 1,
                                // dontBreakRows: true,
                                // keepWithHeaderRows: 1,
                                body: [
                                    [{text: 'Broj:', style: 'miniHeaderTable'}, {text: ''+ invoiceId, style: 'miniHeaderTable'},],
                                    [{text: 'Mesto:', style: 'miniRowTable'}, {text: 'Novi Sad', style: 'miniRowTable'},],
                                    [{text: 'Poziv na broj:', style: 'miniRowTable'}, {text: ''+ invoiceId, style: 'miniRowTable'},],
                                    [{text: 'Datum računa:', style: 'miniRowTable'}, {text: currentDay, style: 'miniRowTable'},],
                                    [{text: 'Datum prometa:', style: 'miniRowTable'}, {text: currentDay, style: 'miniRowTable'},],
                                    [{text: 'Datum valute:', style: 'miniRowTable'}, {text: currentDay, style: 'miniRowTable'},],
                                    // [{text: 'Osnova za račun:', style: 'miniRowTable'}, {text: 'Lovćenska', style: 'miniRowTable'},],
                                ]
                            },
                            layout: 'noBorders'
                        }, {text: '', style:'companyInfo'} ],
                    ]
                },
                layout: 'noBorders'
            },
            {
                style: 'miniTableExample',
                table: {
                    headerRows: 1,
                    widths: ['*',  'auto', 'auto', 'auto'],
                    body: mainBody
                },
                layout: 'lightHorizontalLines'
            },
            {text: locationDetails.length === 0 ? '' : 'Broj članova po lokaciji', style: 'tableHeader'},
            locationDetails.length === 0 ? {text: ''} : {
                style: 'miniTableExample',
                table: {
                    headerRows: 1,
                    widths: ['auto',  'auto'],
                    body: locationDetails
                },
                layout: 'lightHorizontalLines'
            },
            // {
            //     text: [
            //         '\n',
            //         '\n',
            //         {text: 'Uplatu izvršiti na tekući račun broj: ', fontSize: 10, bold: false},
            //         {text: '325-9500700187549-51', fontSize: 10, bold: true},
            //         '\n',
            //         '\n',
            //         {text: 'Napomena: ', fontSize: 10, bold: true},
            //         {text: 'Preduzetnik nije u sistemu PDV. PDV nije obračunat u skladu sa Članom 33 Zakona o PDV.', fontSize: 10, bold: false},
            //         '\n',
            //         '\n',
            //         {text: 'Račun je izdat u elektronskom obliku, nema obaveze štampanja i važeći je bez pečata i potpisa.', fontSize: 10, bold: false},
            //         '\n',
            //         '\n',
            //         {text: 'Izdao račun:', fontSize: 10, bold: true},
            //         '\n',
            //         {text: 'Slobodan Ristić', fontSize: 10, bold: false},
            //
            //     ]
            // },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            headerRacun: {
                fontSize: 36,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            companyInfo: {
                fontSize: 9,
                margin: [0, 10, 0, 5]
            },
            mainHeaderTable: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            mainRowTable: {
                fontSize: 10,
                margin: [0, 0, 0, 0]
            },
            miniHeaderTable: {
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable: {
                fontSize: 8,
                margin: [0, 0, 0, 0]
            },

            miniHeaderTable2: {
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable2: {
                fontSize: 12,
                margin: [0, 0, 0, 0]
            },

            tableExample: {
                margin: [0, 5, 0, 15]
            },
            miniTableExample: {
                margin: [0, 2, 0, 2]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },

    }
    var fileName = 'invoice-'+invoice.id + '-' + currentDayInvoice;
    if(downloadOnly){
        pdfMake.createPdf(dd).download(fileName)
    }else{
        // let _self = this;
        // const pdfDocGenerator = pdfMake.createPdf(dd);
        //
        // pdfDocGenerator.getBase64((data) => {
        //     _self.sendMail(item, data, fileName, dd)
        // });
    }
}



// WEBPACK FOOTER //
// ./src/components/Invoice/Invoices.js